import { Injectable } from '@angular/core';
import { MbiemriLloji } from '@core/enums/mbiemri.enums';
import { MbiemriMashkullorForCreationDTO } from '@core/interfaces/dto/mbiemri-mashkullor-for-creation-dto.interface';

@Injectable({
  providedIn: 'root'
})
export class MbiemriMashkullorService {

  constructor() { }

  getCreationDTO(mbiemriBaza: any) {
    const creationDTO: MbiemriMashkullorForCreationDTO[] = [];

    let formArray: any[] = mbiemriBaza.mbiemriMashkullorEmerMbiemer.concat(mbiemriBaza.mbiemriMashkullorMbiemerEmer);

    for (var i = 0; i < formArray.length; i++) {
      const e = formArray[i];

      if (mbiemriBaza.llojiId == MbiemriLloji.Inyjshem && e.formaFjalesId != null)
        continue;

      creationDTO.push({
        trajtaId: e.trajtaId,
        numriId: e.numriId,
        rasaId: e.rasaId,
        renditjaId: e.renditjaId,
        formaFjalesId: e.formaFjalesId,
        pershkrimi: e.pershkrimi,
        radhitja: e.radhitja
      });
    }

    return creationDTO;
  }
}
